import StockIcon from "./StocktIcon";
import StocksList from "./StockList";

export default {
  list: StocksList,
  icon: StockIcon
};
